export function setupOfficeHelper(officeElement, officeData, I18n) {
    const helper = $(officeElement[0].parentNode).find('.helper-text');
    const tooltipButton = $(officeElement[0].parentNode).find('.tooltip-button');
    let textHelper = '';
    officeData = officeData.split('-');

    const fullTime = officeData[3].split('full_time:')[1];

    if (fullTime === "false") {
        const from = officeData[4].split('open_time:')[1] + ":00am";
        const to = (parseInt(officeData[5].split("close_time:")[1]) - 12) + ":00pm";
        textHelper = I18n.t('global.main.form.work_by_hours', { from, to });
    } else {
        textHelper = I18n.t('global.main.form.work_all_day');
    }

    helper.text(textHelper);
    tooltipButton[0].classList.remove('hide-tooltip');
}

export function extractTimeValues(officeData) {
    officeData = officeData.split('-');
    const openTime = officeData[4].split('open_time:')[1];
    const closeTime = officeData[5].split('close_time:')[1];

    return {
        openTime: openTime.length === 1 ? `0${openTime}` : openTime,
        closeTime: closeTime.length === 1 ? `0${closeTime}` : closeTime
    };
}
